const wordSeparators = /[-_\\.+\s]+/g;
const notAlphaNumericOrSpace = /[^ a-zA-Z0-9]+/g;
const notAlphaNumericSpaceOrDash = /[^ a-zA-Z0-9-]/g;
const capitalizedFirstLetter = /[A-Z]+(?![a-z])|[A-Z]/g;

/**
 * Safely camelCases a string, taking into account acronyms, kebab-case, snake_case, and sentence casing as well as special characters
 * @param string
 * @returns A `string` in camelCase form
 */
export const camelCase = (string: string): string => {
  const cleanedString = string
    .replace(wordSeparators, ' ')
    .replace(notAlphaNumericOrSpace, '')
    .replace(capitalizedFirstLetter, ($, ofs) => (ofs ? ' ' : '') + $.trim().toLowerCase())
    .trim();
  const words = cleanedString.split(' ');
  const camelCasedWords = words.map((word, index) =>
    index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
  );
  const camelCasedString = camelCasedWords.join('');

  return camelCasedString;
};

/**
 * Safely kebab-cases a string, taking into account acronyms, camelCase, snake_case, and sentence casing, as well as special characters
 * @param string
 * @returns a kebab-cased string
 */
export const toKebabCase = (str: string) =>
  str
    .trim()
    .replace(wordSeparators, '-')
    .replace(notAlphaNumericSpaceOrDash, '')
    .replace(capitalizedFirstLetter, ($, ofs) => (ofs ? '-' : '') + $.trim().toLowerCase())
    .replace(/--+/g, '-');

/**
 * Converts a kebab-cased string to a title-cased string
 * @param str - The input kebab-cased string
 * @returns A title-cased string
 */
export const kebabToTitleCase = (str: string): string =>
  str.replace(/(^|\/|-)(\S)/g, s => s.toUpperCase().replaceAll('-', ' '));

/**
 * Adds a trailing slash to a string if it doesn't already have one.
 * @param str - The input string.
 * @returns The input string with a trailing slash.
 */
export const trailingSlash = (str: string) => (str.endsWith('/') ? str : `${str}/`);
